import { createContext, ReactNode, useContext } from 'react'
import { SchedulingMode, UtmSource } from '../../constants'
import { useReferrerContext } from '../useReferrerContext'
import { SearchParameters, useSearchParameters } from '../useSearchParameters'

interface ProviderProps {
  children: ReactNode
}

const context = createContext<SchedulingMode>(SchedulingMode.CONSULTANT)
const { Provider } = context

const SchedulingModeProvider = ({ children }: ProviderProps) => {
  const { [SearchParameters.SCHEDULING_MODE]: searchParamSchedulingMode } = useSearchParameters()
  const referrerContext = useReferrerContext()
  const isReferredByFitterCockpit = referrerContext?.source === UtmSource.FITTER_COCKPIT
  const isReferredByFlowClient = referrerContext?.source === UtmSource.FLOW_CLIENT
  const hasFitterSchedulingModeInQueryString = searchParamSchedulingMode === SchedulingMode.FITTER
  const isFitterSchedulingMode = isReferredByFitterCockpit || isReferredByFlowClient || hasFitterSchedulingModeInQueryString
  const hasPartnerPortalNeoModeInQueryString = searchParamSchedulingMode === SchedulingMode.PARTNER_PORTAL_NEO

  const actualMode: SchedulingMode = hasPartnerPortalNeoModeInQueryString
    ? SchedulingMode.PARTNER_PORTAL_NEO
    : isFitterSchedulingMode
    ? SchedulingMode.FITTER
    : SchedulingMode.CONSULTANT

  return <Provider value={actualMode}>{children}</Provider>
}

const useSchedulingMode = () => useContext(context)

export { SchedulingModeProvider, useSchedulingMode }
export type { SchedulingMode }
